import "./CustomInput.scss";

const CustomInput = ({type, id, name, label, value, onChange, error}) => {
  return (
    <div className="custom-input">
      <input
        className="custom-input__field"
        type={type}
        id={id}
        name={name}
        required
        placeholder=" "
        value={value}
        onChange={onChange}
      />
      <label className="custom-input__label" htmlFor={id}>
        {label}
      </label>
      <div className="custom-input__underline"></div>
      {error && <span className="error">{error}</span>}
    </div>
  );
};

export default CustomInput;